import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { getApplicationRulePermissionGridValues } from '../../../../../utils/uiSettings/contentControl/content-control.values';
import { html, TemplateResult } from 'lit';
import { ContentControlApplicationRule } from '@nirvana/shared/dtos/types/policies/common';

export enum Column {
  APP_PATH = 1,
  PERMISSION,
}

export enum ColumnKeys {
  APP_PATH = 'appPath',
  PERMISSION = 'permission',
}

export const GRID_COLUMNS = [Column.APP_PATH, Column.PERMISSION];

export const FILTERS = [{ [ColumnKeys.APP_PATH]: { contains: '' } }, { [ColumnKeys.PERMISSION]: { in: [] } }];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.APP_PATH, ColumnKeys.PERMISSION];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.APP_PATH,
      key: ColumnKeys.APP_PATH,
      columnName: translateFn('Application path'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.PERMISSION,
      key: ColumnKeys.PERMISSION,
      columnName: translateFn('Permission'),
      type: ColumnType.ENUM,
      values: getApplicationRulePermissionGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
  ];
}

export function appPathCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ContentControlApplicationRule }
): TemplateResult {
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${rowData.item.appPath}</span
  >`;
}
